export const inspections = {
shared: {
  jobVisibility: {
    contractors: "Auftragnehmer",
    team: "Team",
    private: "Privat",
  },
  jobCategory: {
    Other: "Sonstiges",
    Cleaning: "Reinigung",
    Installation: "Einbau",
    Replacement: "Austausch",
    Inspection: "Inspektion",
    Maintenance: "Wartung",
    Repair: "Reparatur",
  },
checklistCategory: {
Inspection: "Inspektion",
Check: "Kontrolle",
Audit: "Prüfung",
SafetyReview: "Sicherheitsprüfung",
Maintenance: "Wartung",
General: "Allgemein",
},
itemsAnswered_one: "{{value}} von {{count}} Punkt beantwortet ({{percent}}%)",
itemsAnswered_other: "{{value}} von {{count}} Punkten beantwortet ({{percent}}%)",
workflowRationale: {
explicit: "Für diese Inspektion ausgewählt.",
lastUsed: "Zuletzt für diese Anlage verwendet.",
bestMatch: "Am besten passender Ablauf für diesen Anlagentyp.",
history: "Basierend auf den letzten {{inspections}} dieser Anlage ({{every}}).",
historyInspections_one: "{{count}} Inspektion",
historyInspections_other: "{{count}} Inspektionen",
historyEvery_one: "etwa täglich",
historyEvery_other: "etwa alle {{count}} Tage",
assetTypeDefault: {
car: "Übliches Anfangsintervall für Fahrzeuge – bei Bedarf anpassen.",
property: "Übliches Anfangsintervall für Immobilien – bei Bedarf anpassen.",
equipment: "Übliches Anfangsintervall für Ausrüstung – bei Bedarf anpassen.",
other: "Übliches Anfangsintervall für sonstige Anlagen – bei Bedarf anpassen.",
},
},
executionMode: {
list: "Liste",
guidedGroup: "Geführt nach Gruppe",
guidedItem: "Geführt nach Punkt",
},
recordStatus: {
inProgress: "In Bearbeitung",
paused: "Pausiert",
submitted: "Eingereicht",
approved: "Abgezeichnet",
completed: "Abgeschlossen",
cancelled: "Abgebrochen",
},
},
start: {
  planningLoadErrorTitle: "Planung konnte nicht geöffnet werden",
  planningAssetUnavailable: "Diese Anlage ist nicht verfügbar oder Sie haben keinen Zugriff mehr darauf.",
  planningAssetMismatch: "Diese Anfrage gehört zu einer anderen Anlage. Öffnen Sie die Anfrage und versuchen Sie es erneut.",
  planningLoading: "Wird vorbereitet…",
  planningTitle: "Arbeit planen",
setupRequiredTitle: "Einrichtung erforderlich",
setupRequiredBodyAll: "Fügen Sie mindestens eine Anlage und eine Checkliste hinzu, bevor Sie eine Prüfung starten.",
setupRequiredBodyAssets: "Fügen Sie mindestens eine Anlage hinzu, bevor Sie eine Prüfung starten.",
setupRequiredBodyTemplates: "Erstellen Sie mindestens eine Checkliste, bevor Sie eine Prüfung starten.",
addAsset: "Anlage hinzufügen",
createChecklist: "Checkliste erstellen",
createChecklistA11y: "Checkliste erstellen",
createChecklistSheetTitle: "Checkliste erstellen",
createChecklistSheetSubtitle: "Wählen Sie, wie Sie Ihre Checkliste erstellen möchten.",
createChecklistWithAi: "Mit KI generieren",
createChecklistManually: "Manuell erstellen",
overlayReturnFootnote: "Öffnet sich in einem Overlay. Nach dem Speichern kehren Sie hierher zurück, um zu starten oder zu planen.",
stepSelectAsset: "1. Anlage auswählen",
searchAssetsPlaceholder: "Anlagen suchen",
searchAssetsA11y: "Anlagen suchen",
allTypesA11y: "Alle Anlagentypen anzeigen",
tapSelectedAssetToChange: "Tippen Sie auf die ausgewählte Anlage, um sie zu ändern.",
noAssetsMatch: "Keine Anlagen entsprechen Ihrer Suche.",
stepSelectChecklist: "2. Checkliste auswählen",
noChecklistsForAssetType: "Keine Checklisten passen zum Anlagentyp {{assetType}}.",
selectAssetFirst: "Wählen Sie zuerst eine Anlage aus, um passende Checklisten anzuzeigen.",
searchChecklistsPlaceholder: "Checklisten suchen",
searchChecklistsA11y: "Checklisten suchen",
showingChecklistsFor: "Checklisten für {{assetType}} werden angezeigt",
tapSelectedChecklistToChange: "Tippen Sie auf die ausgewählte Checkliste, um sie zu ändern.",
noChecklistsMatch: "Keine Checklisten entsprechen Ihrer Suche.",
stepAssignInspector: "3. Zuweisen und starten",
youSuffix: " (Sie)",
you: "Sie",
onlyTeamMember: "Derzeit ist nur Ihr Teammitglied verfügbar.",
createTeamToAssign: "Erstellen Sie ein Team, um Prüfungen an andere zuzuweisen.",
executionModeLabel: "Ausführungsmodus",
locationTitle: "Aktueller Standort",
locationLoading: "Ihr Standort wird ermittelt...",
locationNotSupported: "Standortbestimmung wird auf diesem Gerät nicht unterstützt.",
locationPermissionDenied: "Die Standortberechtigung wurde verweigert.",
locationUnavailableFallback: "Standort ist nicht verfügbar.",
locationUnavailableMessage: "Standort nicht verfügbar: {{reason}}",
starting: "Wird gestartet...",
startInspection: "Prüfung starten",
prefilledMomentumHint: "Prüfen Sie die Auswahl unten und tippen Sie dann auf Prüfung starten.",
scheduleForLater: "Für später planen",
noPriority: "Keine Priorität",
requestContextEyebrow: "Prüfung zur Anfrage",
requesterNotSet: "Nicht angegeben",
requestHandoff: {
requesterFallback: "der Antragsteller",
decisionStartNow: "Entscheidung: jetzt starten",
},
alerts: {
selectAsset: "Wählen Sie eine Anlage aus, bevor Sie fortfahren.",
selectChecklist: "Wählen Sie eine Checkliste aus, bevor Sie fortfahren.",
selectAssetAndChecklist: "Wählen Sie eine Anlage und eine Checkliste aus, um zu starten.",
assetArchivedTitle: "Archivierte Anlage",
assetArchivedBody: "Archivierte Anlagen können nicht geprüft werden. Wählen Sie eine andere Anlage.",
assetArchivedScheduleBody: "Für archivierte Anlagen können keine Prüfungen geplant werden. Wählen Sie eine andere Anlage.",
couldNotStartTitle: "Prüfung konnte nicht gestartet werden",
couldNotStartBody: "Bitte versuchen Sie es erneut.",
},
},
share: {
title: "Bericht teilen",
},
report: {
coverEyebrow: "Zustandsbericht",
coverUntitled: "Unbenannte Anlage",
sectionSubject: "Prüfgegenstand",
statInspected: "Geprüft",
statRepairs: "Reparaturen",
statEstTotal: "Geschätzte Summe",
},
sentForApproval: {
subtitle: "Wir senden einen Prüflink per E-Mail. Sie werden benachrichtigt, sobald geantwortet wird.",
backToHome: "Zurück zur Startseite",
viewReport: "Bericht anzeigen",
},
detail: {
  sendBack: {
    errors: {
      notAllowed: "Nur die Person, die Arbeiten an dieser Anlage freigibt, kann sie zurückschicken.",
      notWaiting: "Diese Inspektion wartet nicht mehr auf Freigabe. Vielleicht hat sie gerade jemand freigegeben oder zurückgeschickt.",
      ownWork: "Eine Inspektion, die Sie selbst durchgeführt haben, können Sie nicht zurückschicken.",
      reasonRequired: "Schreiben Sie 3 bis 1.000 Zeichen, damit klar ist, was zu korrigieren ist.",
    },
    noticeHint: "Korrigieren Sie, worum gebeten wurde, und tippen Sie dann erneut auf „Inspektion abschließen“. Sie geht zur Freigabe zurück.",
    noticeReason: "„{{reason}}“",
    noticeTitle: "{{name}} hat dies zurückgeschickt",
    approverFallback: "Die freigebende Person",
    inspectorFallback: "die prüfende Person",
    failedTitle: "Zurückschicken nicht möglich",
    sent: "An {{name}} zurückgeschickt. Ihre Begründung wird angezeigt.",
    sending: "Wird zurückgeschickt…",
    confirm: "Zurückschicken",
    reasonTooShort: "Schreiben Sie ein paar Worte, damit klar ist, was zu korrigieren ist.",
    reasonPlaceholder: "Zum Beispiel: Fügen Sie ein Foto des Dachablaufs hinzu.",
    reasonLabel: "Was korrigiert werden muss",
    hint: "Sagen Sie, was korrigiert werden muss. {{name}} erhält eine Benachrichtigung, und die Inspektion wird für diese Person wieder geöffnet.",
    title: "An {{name}} zurückschicken",
    buttonA11y: "Diese Inspektion mit einer Begründung an {{name}} zurückschicken",
    button: "Zurückschicken",
  },
  errors: {
    completeTitle: "Inspektion konnte nicht abgeschlossen werden",
    deleteTitle: "Inspektion konnte nicht gelöscht werden",
    continueTitle: "Inspektion konnte nicht fortgesetzt werden",
    takeOverTitle: "Konnte nicht stellvertretend erledigt werden",
    reopenTitle: "Inspektion konnte nicht wieder geöffnet werden",
    approveTitle: "Inspektion konnte nicht genehmigt werden",
    suggestionTitle: "Vorschlag konnte nicht hinzugefügt werden",
    reloadTitle: "Die andere Version konnte nicht geladen werden",
    mergeTitle: "Ihre Antworten konnten nicht übernommen werden",
    checkConnection: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  },
  outline: {
    title: "Punkte · {{done}} von {{total}} beantwortet",
    jumpA11y: "Zu Punkt {{n}}, {{label}}, {{state}}",
    state: { failed: "nicht bestanden", done: "beantwortet", skipped: "übersprungen", pending: "noch offen" },
  },
findingsNextActionsTitle: "Ergebnisse und nächste Maßnahmen",
assetContext: {
asset: "Anlage",
previousOnThisAsset: "Frühere Inspektionen dieser Anlage",
manuals: "Handbücher",
noAssetLinked: "Keine Anlage verknüpft",
openAsset: "Anlage öffnen →",
openAssetA11y: "Anlage öffnen",
},
approval: {
  fixAndResend: "Korrigieren und erneut senden",
  fixHint: "Beheben Sie das Angeforderte und senden Sie den Bericht dann erneut.",
  changesAskedNoReason: "{{name}} hat Änderungen angefordert.",
  changesAsked: "{{name}} hat Änderungen angefordert: „{{reason}}“",
  linkCopied: "Link kopiert. Fügen Sie ihn in eine Nachricht an {{name}} ein.",
  sendAgainA11y: "Bericht erneut an {{name}} senden",
  sendAgain: "Erneut senden",
  sentToDue: "Am {{date}} an {{name}} gesendet · Antwort bis {{due}}",
  sentTo: "Am {{date}} an {{name}} gesendet",
  summary: {
    nextNotShared: "Schließen Sie die Inspektion ab und teilen Sie den Bericht, wenn jemand ihn genehmigen muss.",
    nextWaitingFor: "Warten darauf, dass {{name}} diese Inspektion abzeichnet.",
    nextWaitingForTeam: "Wartet darauf, dass jemand aus {{name}} diese Inspektion abzeichnet.",
    nextStepWaited_one: "{{nextStep}} Wartet seit {{count}} Tag.",
    nextStepWaited_other: "{{nextStep}} Wartet seit {{count}} Tagen.",
    nextYouApprove: "Prüfen Sie die Befunde und tippen Sie dann auf Abzeichnen.",
    nextWaitingShared: "Warten auf die Antwort der Person, mit der Sie geteilt haben.",
    nextResponded: "Lesen Sie die Antwort und entscheiden Sie, wie es weitergeht.",
    nextRespondedJobs: "Genehmigte Reparaturen können jetzt zu Aufträgen werden.",
    nextChangesRequested: "Lesen Sie das Feedback, aktualisieren Sie die Inspektion und teilen Sie sie erneut.",
    nextApproved: "Abgezeichnet. Öffnen Sie Nächste Schritte oder teilen Sie den Bericht.",
    nextApprovedJobs: "Prüfen Sie die genehmigten Reparaturen und legen Sie dann die Aufträge an.",
    noApproverYet: "Noch keine genehmigende Person",
    recipientFallback: "Empfänger",
    statusNotShared: "Nicht geteilt",
    statusAwaiting: "Wartet auf Abzeichnung",
    statusResponded: "Beantwortet",
    statusChangesRequested: "Änderungen angefordert",
    statusApproved: "Abgezeichnet",
  },
  askAiDraft: "Hilf mir, die Inspektion {{checklist}} an {{asset}} vom {{date}} zu prüfen und den nächsten Schritt festzulegen.",
  closeIt: "Schließen",
  keepWaiting: "Weiter warten",
  closeConfirmBody: "{{name}} hat nicht geantwortet. Die vorgeschlagenen Reparaturen werden in deren Namen als nicht genehmigt erfasst.",
  closeConfirmTitle: "Ohne Antwort schließen?",
  takeOverSignedOff: "Anstelle von {{name}} genehmigt",
  takeOverClosed: "Ohne Antwort geschlossen",
  takeOverApproved: "Für {{name}} genehmigt",
  teamApprover: "Jedes Mitglied von {{name}}",
  assetApprover: "Genehmigende Person für die Anlage",
  approverFallback: "die genehmigende Person",
  reopenConfirm: "Wieder öffnen",
  reopenConfirmBody: "Sie können die Antworten wieder ändern und die Inspektion dann erneut abschließen.",
  reopenConfirmApproved: "{{name}} hat sie genehmigt. Beim Wiederöffnen wird die Genehmigung entfernt und muss erneut erteilt werden.",
  reopenConfirmTitle: "Diese Inspektion wieder öffnen?",
approval: "Genehmigung",
statusSummaryA11y: "Genehmigungsstatus: {{status}}. {{action}}",
collapse: "Einklappen",
showDetails: "Details anzeigen",
currentStatus: "Aktueller Status",
approver: "Genehmiger",
nextStep: "Nächster Schritt",
approveInspectionA11y: "Diese Inspektion abzeichnen",
approving: "Wird abgezeichnet…",
approveInspection: "Abzeichnen",
openNextStepsA11y: "Nächste Schritte öffnen",
nextSteps: "Nächste Schritte",
shareReportA11y: "Teilen Sie den Bericht",
shareReport: "Bericht teilen",
reopenAndClearA11y: "Diese Inspektion wieder öffnen und die Genehmigung aufheben",
reopenA11y: "Öffnen Sie diese Inspektion erneut",
reopening: "Wird wieder geöffnet…",
reopenAndClear: "Wieder öffnen und Genehmigung aufheben",
reopenInspection: "Inspektion wieder öffnen",
},
lifecycle: {
pauseTitle: "Inspektion pausieren",
pauseHint: "Fügen Sie optional einen Grund und einen Zeitplan für die Wiederaufnahme hinzu.",
reasonOptional: "Grund (optional)",
pauseReasonPlaceholder: "z.B. Warten auf Teile, Genehmigung durch den Kunden erforderlich",
resumeDateOptional: "Datum der Fortsetzung (optional)",
selectDate: "Datum wählen",
resumeTimeOptional: "Wiederaufnahmezeit (optional)",
selectTime24h: "Zeit auswählen (24h)",
cancel: "Abbrechen",
pause: "Pausieren",
cancelTitle: "Inspektion abbrechen",
cancelHint: "Der Fortschritt wird gespeichert, aber die Inspektion wird als abgebrochen markiert. Bitte geben Sie einen Grund an.",
cancellationReason: "Stornierungsgrund",
cancelReasonPlaceholder: "z.B. Anlage verkauft, doppelte Inspektion, falsche Checkliste",
back: "Inspektion behalten",
cancelInspection: "Inspektion abbrechen",
reassignTitle: "Inspektion neu zuweisen",
reassigned: "Neu zugewiesen an {{name}}. Die Inspektion bleibt für diese Person in Bearbeitung.",
reassignFailed: "Die Inspektion konnte nicht neu zugewiesen werden. Bitte erneut versuchen.",
pickContractorTitle: "An einen Auftragnehmer geben",
contractorNoAccountTitle: "Noch kein AssetWRX-Konto",
contractorNoAccountBody: "{{name}} braucht ein AssetWRX-Konto, um eine Inspektion durchzuführen. Laden Sie ihn über Kontakte ein; sobald er beitritt, können Sie sie ihm geben.",
cancelReasonRequired: "Bitte geben Sie einen Grund für den Abbruch an.",
cancelledTitle: "Abgebrochen",
cancelledBody: "Die Inspektion wurde abgebrochen.",
cancelFailed: "Die Inspektion konnte nicht abgebrochen werden. Bitte erneut versuchen.",
pauseFailed: "Die Inspektion konnte nicht angehalten werden. Bitte erneut versuchen.",
errorTitle: "Fehler",
searchTeamMembersPlaceholder: "Teammitglieder suchen…",
noTeamMemberMatch: "Kein passendes Teammitglied.",
skipTitle: "Diesen Punkt überspringen?",
skipHint: "Fügen Sie eine kurze Notiz hinzu, wenn es Ihrem Team hilft (optional). Tippen Sie zur Bestätigung auf Überspringen.",
noteOptional: "Hinweis (optional)",
skipReasonPlaceholder: "z.B. Kein Zugriff, nicht anwendbar",
skip: "Überspringen",
},
repair: {
proposedFollowUp: "Auftrag nötig?",
confirmedAfterCompletion: "(bestätigt nach Fertigstellung)",
markForFollowUp: "Ja, dafür einen Auftrag anlegen",
titleField: "Titel *",
titlePlaceholder: "z.B. Undichten Wasserhahn reparieren",
priority: "Priorität",
priorityFallback: "Mittel",
description: "Beschreibung *",
descriptionPlaceholder: "Was muss getan werden...",
descriptionFallback: "Keine",
hideOptionsA11y: "Folgeoptionen ausblenden",
showOptionsA11y: "Weitere Folgeoptionen anzeigen",
lessOptions: "Weniger Optionen",
moreOptions: "Weitere Optionen",
repairCategory: "Reparaturkategorie",
repairCategoryFallback: "Reparatur",
skillsOptional: "Kenntnisse (optional)",
skills: "Fähigkeiten",
selected: "Ausgewählt",
none: "Keine",
dueDateOptional: "Fälligkeitsdatum (optional)",
visibility: "Sichtbarkeit",
visibilityFallback: "Privat",
estimatedCostOptional: "Geschätzte Kosten (optional)",
notSet: "Nicht gesetzt",
costPlaceholder: "0,00",
requiresUrgentRepair: "Erfordert dringende Reparatur",
urgentRepairNoteLabel: "Dringender Reparaturhinweis",
noNote: "Keine Anmerkung",
markFollowUpHintPrefix: "Nach Abschluss der Inspektion bestätigen Sie diesen Auftrag unter ",
markFollowUpHintSuffix: ", bevor er angelegt wird.",
},
urgentNote: {
placeholder: "Warum dringend?",
stop: "Stopp",
dictate: "Diktieren",
cleaningUpEllipsis: "Aufräumen...",
aiCleanUp: "Mit KI bereinigen",
addNoteFirstTitle: "Fügen Sie zuerst eine Notiz hinzu",
addNoteFirstBody: "Geben Sie eine kurze Notiz ein, bevor Sie die KI-Bereinigung verwenden.",
cleaningUp: "Dringende Notiz wird bereinigt",
unableToCleanUpTitle: "Notiz konnte nicht bereinigt werden",
cleanedUpTitle: "Dringende Notiz bereinigt",
reviewSuggestedWording: "Überprüfen Sie den vorgeschlagenen Wortlaut, bevor Sie ihn übernehmen.",
},
followUpModal: {
eyebrow: "Inspektionsaktion",
title: "Auftrag nötig?",
closeA11y: "Folgeauftrag schließen",
saveHint: "Haken setzen und die Inspektion abschließen. Sie bestätigen den Auftrag, bevor er angelegt wird.",
doneEditingA11y: "Die Bearbeitung der vorgeschlagenen Folgemaßnahmen ist abgeschlossen",
done: "Fertig",
},
imageFindingsOverlay: {
findingA11y: "Ergebnis: {{label}}",
confidenceSeverity: "Konfidenz: {{confidence}}% · Schweregrad: {{severity}}",
removeMarkerA11y: "Befundmarkierung entfernen",
removeMarker: "Markierung entfernen",
close: "Schließen",
},
quickRating: {
quickRatingA11y: "Schnelle Bewertung",
yes: "Ja",
no: "Nein",
quickLevelA11y: "Schnelle Füllstandsbewertung",
conditionRatingA11y: "Zustandsbewertung",
},
imageViewer: {
couldNotLoad: "Bild konnte nicht geladen werden",
closeA11y: "Bildansicht schließen",
},
noteSheet: {
eyebrow: "Inspektionshinweis",
title: "Notiz hinzufügen",
closeA11y: "Hinweis schließen",
hint: "Geben Sie es ein oder diktieren Sie es und es landet in derselben Notiz.",
placeholder: "Inspektionsnotizen hinzufügen...",
dictateStop: "Diktat beenden",
dictateFinishing: "Wird abgeschlossen…",
dictateUnavailable: "Diktat nicht verfügbar",
dictateIdle: "Diktieren",
doneA11y: "Fertig",
done: "Fertig",
},
imageAnalysis: {
coverage: {
observed: "Im Bild",
partial: "Teilweise im Bild",
not_observed: "Nicht im Bild: bitte manuell beantworten",
},
analysePhoto: "Foto mit KI analysieren",
analysePhotoA11y: "Foto mit KI analysieren",
aiQueued: "KI-Analyse in der Warteschlange",
photoAnalysisTitle: "Fotoanalyse",
analysing: "Analyse...",
suggestedComment: "Vorgeschlagener Kommentar",
severity: "Schweregrad: {{severity}}",
status: "Status: {{status}}",
findings: "Befunde",
appendToComments: "An Kommentare anhängen",
replaceComments: "Kommentare ersetzen",
ignore: "Ignorieren",
removeFindingA11y: "Entfernen Sie den Befund {{label}}",
remove: "Entfernen",
replaceConfirmTitle: "Kommentare ersetzen?",
replaceConfirmBody: "Dadurch wird Ihre vorhandene Notiz durch den KI-Vorschlag ersetzt.",
replaceConfirmCancel: "Abbrechen",
replaceConfirmReplace: "Ersetzen",
},
runnerHeader: {
doneCount: "{{completed}}/{{total}} fertig",
failCount: "{{count}} nachzuverfolgen",
urgentCountLabel_one: "{{count}} dringend",
urgentCountLabel_other: "{{count}} dringend",
modeLabel: {
list: "Liste",
guidedGroup: "Nach Gruppe",
guidedItem: "Nach Punkt",
},
modeDesc: {
list: "Alle Punkte auf einmal anzeigen",
guidedGroup: "Eine Gruppe nach der anderen",
guidedItem: "Ein Element nach dem anderen",
},
cancelled: "Abgebrochen",
paused: "Pausiert",
sectionEyebrow: "Abschnitt {{index}} von {{count}}",
openAssetA11y: "Öffnen Sie {{assetName}}",
openSyncConflictA11y: "Optionen für Synchronisierungskonflikte öffnen",
retrySaveA11y: "Versuchen Sie erneut, Inspektionsantworten zu speichern",
review: "Prüfen",
retry: "Wiederholen",
askAiCompactA11y: "Basierend auf Ihren Antworten kann KI bei den nächsten Kontrollen helfen",
askAiWideA11y: "KI kann bei den nächsten Kontrollen helfen",
jumpToIncompleteA11y: "Zum nächsten unvollständigen erforderlichen Element springen",
jumpToIncomplete: "Zum Unvollständigen springen",
changeModeA11y: "Ansichtsmodus ändern. Aktuell: {{mode}}",
viewAsTitle: "Diese Inspektion anzeigen als",
modeOptionA11y: "{{mode}}: {{desc}}",
viewModeAction: "Ansicht: {{mode}}",
viewModeTooltip: "Ändern Sie die Darstellung der Checkliste",
},
},
overview: {
statusApproved: "Genehmigt",
statusCompleted: "Abgeschlossen",
statusCancelled: "Abgebrochen",
statusPaused: "Pausiert",
statusInProgress: "In Bearbeitung",
items: "Punkte",
progress: "Fortschritt",
failures: "Nicht bestanden",
urgent: "Dringend",
resumeLabel: "Fortsetzung: {{text}}",
operationalTimelineA11y_one: "Betriebszeitleiste, {{count}} Ereignis",
operationalTimelineA11y_other: "Betriebszeitleiste, {{count}} Ereignisse",
operationalTimelineTitle: "Betriebszeitleiste · {{count}}",
whoLabel: "Wer: {{actor}}",
whenLabel: "Wann: {{when}}",
},
photoEvidence: {
photos: "Fotos",
mediaGuidance: "Bis zu 3 Fotos pro Punkt · vor dem Speichern darauf zeichnen, um Stellen hervorzuheben.",
noPhotosTaken: "Keine Fotos gemacht",
evidencePhotoA11y: "{{label}} – Nachweisfoto {{index}} von {{count}}. Vollbild anzeigen",
},
shareSection: {
  statusChanges: "Änderungen angefordert",
  statusApproved: "Genehmigt",
  statusWaiting: "Ausstehend",
  messageA11y: "Prüfung mit {{name}} öffnen",
reportSharedWith: "Bericht geteilt mit",
message: "Nachricht",
createJobs: "Aufträge erstellen",
revoke: "Entziehen",
revokeAccessA11y: "Widerrufen Sie den Berichtszugriff für {{name}}",
revokeConfirmTitle: "Berichtszugriff widerrufen?",
revokeConfirmBody: "{{name}} kann den Berichtslink nicht mehr öffnen. Die Freigabehistorie bleibt erhalten.",
revokeConfirmCancel: "Abbrechen",
revokeConfirmConfirm: "Zugriff entziehen",
revokeFailedTitle: "Der Zugriff konnte nicht widerrufen werden",
revokeFailedBody: "Bitte versuchen Sie es gleich noch einmal.",
recipientFallback: "Dieser Empfänger",
},
checklistSection: {
batchHintRange: "Punkte {{from}}–{{to}} von {{total}}",
prefillNotice: "Vorherige Inspektion{{dateSuffix}}. Ergebnisse und Notizen vom letzten Mal werden als Referenz angezeigt. Notieren Sie für jede Prüfung das aktuelle Ergebnis.",
prefillNoticeDateSuffix: " vom {{date}}",
emptyGroup: "In dieser Gruppe gibt es nichts zu erledigen.",
},
evidenceRail: {
collapseA11y: "{{title}} einklappen",
hide: "Ausblenden",
},
swipeableWrap: {
ok: "OK",
skip: "Überspringen",
},
kpis: {
items: "Punkte",
status: "Status",
cost: "Geschätzte Kosten",
reviews: "Überprüfungen",
percentDone: "{{percent}}% fertig",
statusInProgress: "In Bearbeitung",
},
summaryCard: {
  suggestedTitle: "Vorgeschlagene Zusammenfassung",
title: "Inspektionszusammenfassung",
editSummary: "Zusammenfassung bearbeiten",
noSummaryYet: "Noch keine Zusammenfassung",
generatedAt: "Generiert {{date}}",
regenerate: "Neu generieren",
generate: "Generieren",
generating: "Wird generiert...",
buildingSummary: "Zusammenfassung wird aus den Inspektionsdaten erstellt...",
noCredits: "Kein Nutzungsguthaben mehr, daher kann keine Zusammenfassung erstellt werden. Kaufen Sie ein Guthabenpaket oder warten Sie auf Ihr monatlich enthaltenes Guthaben.",
noCreditsMember: "Kein Nutzungsguthaben mehr, daher kann keine Zusammenfassung erstellt werden. Bitten Sie einen Admin des Arbeitsbereichs, Guthaben zu kaufen, oder warten Sie auf Ihr monatlich enthaltenes Guthaben.",
noCreditsOnDevice: "Kein Nutzungsguthaben mehr, daher kann keine Zusammenfassung erstellt werden. Guthaben wird in AssetWRX im Web gekauft oder kommt mit Ihrem monatlich enthaltenen Guthaben.",
topUp: "Guthaben kaufen",
},
valueAnswer: {
readingLabel: "Messwert",
textLabel: "Antwort",
textPlaceholder: "Eingeben oder scannen",
scan: "Scannen",
detected: "Erkannt: {{value}}",
detectedOnDevice: "Auf diesem Gerät gelesen, keine KI-Credits verbraucht",
use: "Übernehmen",
ignore: "Ignorieren",
},
checklistEditor: {
required: "Pflichtfeld",
yes: "Ja",
no: "Nein",
ratingReading: "Messwert",
ratingText: "Text",
meterLabel: "Zähler",
meterHintMissing: "Wählen Sie aus, welcher Zähler das ist. Nur dann wird der Wert beim Abschließen der Inspektion in den Zählerverlauf der Anlage übernommen.",
meterHintUnit: "Geben Sie die Einheit an (zum Beispiel bar oder °C), damit der Wert in den Zählerverlauf der Anlage übernommen werden kann.",
meterHintSaved: "Wird beim Abschließen der Inspektion als {{meter}}-Stand der Anlage gespeichert und zählt für die zählerbasierte Wartung.",
meterHours: "Stunden",
meterDistance: "Strecke",
meterCycles: "Zyklen",
meterOther: "Andere",
unitLabel: "Einheit",
visionCanAssist: "Vision kann das anhand eines Fotos beantworten",
useVision: "Diesen Abschnitt mit Vision scannen",
visionOff: "Aus",
visionAvailable: "Verfügbar",
visionRecommended: "Empfohlen",
evidenceAlways: "Fotonachweis erwartet",
evidenceOnFail: "Fotonachweis bei Mangel erwartet",
measureLabel: "Messart",
ratingCondition: "Zustand",
ratingLevel: "Füllstand",
ratingYesNo: "Ja/Nein",
ratingPassFailNa: "Bestanden/Nicht bestanden/N/A",
ratingPassFlagFail: "Bestanden/Auffällig/Nicht bestanden",
failWhenLabel: "Nicht bestanden bei",
yesNoFailHint: "Verwenden Sie „Ja“ für Fragen nach einem Problem (z. B. „Irgendwelche Risse?“). Verwenden Sie „Nein“ für Fragen zur Einhaltung (z. B. „Ist ein Schutz angebracht?“).",
captureLabel: "Erfassen",
images: "Bilder",
videos: "Videos",
groupNameA11y: "Gruppenname",
groupNamePlaceholder: "Gruppenname",
itemLabelA11yIndexed: "Bezeichnung von Punkt {{index}}",
itemLabelPlaceholder: "Bezeichnung des Punkts",
itemDescriptionA11yIndexed: "Beschreibung von Punkt {{index}} (optional)",
descriptionOptionalPlaceholder: "Beschreibung (optional)",
addItemToGroup: "Element zur Gruppe hinzufügen",
moveUpA11y: "Nach oben verschieben",
moveDownA11y: "Nach unten verschieben",
removeGroupA11y: "Gruppe entfernen",
removeItemA11y: "Element entfernen",
dragA11y: "Neu anordnen: gedrückt halten, dann ziehen",
itemLabelA11y: "Bezeichnung des Punkts",
itemLabelPlaceholderExample: "Bezeichnung des Punkts (z. B. Motoröl prüfen)",
itemDescriptionA11y: "Beschreibung des Punkts (optional)",
requiredNeedsOneItem: "Eine Checkliste benötigt mindestens ein Element.",
groupDefaultLabel: "Gruppe {{number}}",
inspectionNotFoundTitle: "Inspektion nicht gefunden",
couldNotLoadItemsBody: "Diese Inspektion konnte nicht geladen werden, um Elemente zu kopieren.",
noItemsToCopyTitle: "Keine Elemente zum Kopieren",
noItemsToCopyBody: "Diese Inspektion enthält keine Checklistenelemente, die als Checkliste verwendet werden könnten.",
couldNotLoadInspectionTitle: "Die Inspektion konnte nicht geladen werden",
tryAgainOrCreateManually: "Versuchen Sie es erneut oder erstellen Sie die Checkliste manuell.",
workflowCopySuffix: "{{name}} (Workflow-Kopie)",
unsavedTemplateMessage: "Diese Checkliste wurde noch nicht gespeichert. Gehen und sie verlieren?",
    unsavedEditsMessage: "Diese Checkliste hat ungespeicherte Änderungen. Verlassen und verlieren?",
    createFailed: "Checkliste konnte nicht erstellt werden.",
    updateFailed: "Checkliste konnte nicht aktualisiert werden.",
unsavedTemplateEditMessage: "Diese Checkliste weist nicht gespeicherte Änderungen auf. Gehen und sie verlieren?",
templateNameLabel: "Checklistenname *",
templateNameA11y: "Checklistenname (erforderlich)",
templateNamePlaceholder: "z.B. Fahrzeuginspektion vor dem Kauf",
generateDraft: "Entwurf erstellen",
templateDetailsTitle: "Checklistendetails und Sichtbarkeit",
templateDetailsSummary: "Anlagenkompatibilität, Beschreibung, Kategorien und Teamsichtbarkeit.",
assetTypeCompatibility: "Anlagentyp-Kompatibilität",
assetTypeHint: "Wählen Sie einen Anlagentyp aus, für den diese Checkliste gilt. Leer lassen, damit sie für alle Typen gilt.",
customTypesLabel: "Ihre Anlagentypen",
customTypesHint: "Wählen Sie Typen, um diese Checkliste nur für sie zu verwenden. Leer lassen für jede Anlage der oben gewählten Art.",
placeTypesLabel: "Ortsarten",
placeTypesHint: "Wählen Sie Ortsarten wie Raum, um diese Checkliste nur dort zu verwenden. Leer lassen für jeden Ort.",
any: "Beliebig",
visibilityLabel: "Sichtbarkeit",
visibilityAllTeams: "Alle Teams im Konto können diese Checkliste verwenden",
visibilityOnlySelectedTeams: "Nur ausgewählte Teams (Standard: Ihr aktuelles Team)",
visibilityCreateTeamHint: "Erstellen Sie ein Team im Konto, um die Sichtbarkeit einzuschränken",
descriptionHint: "Kurze Zusammenfassung bei der Auswahl dieser Checkliste. Optional.",
descriptionPlaceholderExample: "z.B. Fahrzeugcheck vor dem Kauf",
categoriesLabel: "Kategorien",
categoriesHint: "Wählen Sie eine oder mehrere Kategorien aus",
checklistItemsTitle: "Checklistenelemente",
addGroup: "Gruppe hinzufügen",
addItem: "Element hinzufügen",
saveChecklist: "Checkliste speichern",
templateStructureTitle: "Checklistenstruktur",
evidenceCoverageTitle: "Nachweisabdeckung",
evidenceCoverageCopy_one: "{{count}} Element erfasst derzeit mindestens einen Nachweistyp.",
evidenceCoverageCopy_other: "{{count}} Elemente erfassen derzeit mindestens einen Nachweistyp.",
versioningTitle: "Versionierung",
versioningCopy: "Ihre Änderungen werden als neue Version gespeichert. Bereits begonnene Inspektionen behalten ihre ursprüngliche Checkliste.",
newTemplateTitle: "Neue Checkliste",
templateNotFound: "Checkliste nicht gefunden",
loadingTemplate: "Checkliste wird geladen…",
startTemplateTitle: "Erstellen Sie Ihre Checkliste",
startTemplateBody: "Fügen Sie das erste Element oder die erste Gruppe hinzu, die Ihr Inspektor durchlaufen soll. Oder nutzen Sie KI, um einen Entwurf zu erstellen.",
addFirstItem: "Fügen Sie Ihren ersten Punkt hinzu",
addAGroup: "Eine Gruppe hinzufügen",
validationTitle: "Validierung",
failedToCreateChecklist: "Checkliste konnte nicht erstellt werden.",
failedToUpdateChecklist: "Checkliste konnte nicht aktualisiert werden.",
editTemplateTitle: "Checkliste bearbeiten",
saveChanges: "Änderungen speichern",
},
checklistDetail: {
loadErrorTitle: "Diese Checkliste konnte nicht geladen werden",
categoryGeneral: "Allgemein",
versionLabel: "Version v{{version}}",
updatedDate: "{{date}} aktualisiert",
currentVersionIdLabel: "Aktuelle Versions-ID:",
versionIdNotSet: "Nicht gesetzt",
assetTypesLabel: "Anlagentypen:",
allAssetTypesShort: "Alle",
scopeLabel: "Geltungsbereich:",
versionRowLabel: "Version:",
versionRowValue: "v{{version}}",
createdRowLabel: "Erstellt:",
updatedRowLabel: "Aktualisiert:",
selectedTeamsOnly: "Nur ausgewählte Teams",
structureLabel: "Struktur:",
groupsCount_one: "{{count}} Gruppe",
groupsCount_other: "{{count}} Gruppen",
itemsCount_one: "{{count}} Element",
itemsCount_other: "{{count}} Elemente",
requiredCountSuffix_one: ", {{count}} erforderlich",
requiredCountSuffix_other: ", {{count}} erforderlich",
useTemplateForInspectionA11y: "Checkliste zur Inspektion verwenden",
itemsCountTitle: "Punkte · {{count}}",
required: "Erforderlich",
ungrouped: "Nicht gruppiert",
},
suggestScreen: {
  partialCreatedBody_other: "{{count}} von {{total}} Aufträgen angelegt. „{{title}}“ konnte nicht angelegt werden. Versuchen Sie es erneut.",
  partialCreatedBody_one: "{{count}} von {{total}} Aufträgen angelegt. „{{title}}“ konnte nicht angelegt werden. Versuchen Sie es erneut.",
  linkFailed_other: "{{count}} Aufträge angelegt, konnten aber nicht zur Anfrage hinzugefügt werden. Versuchen Sie es erneut.",
  linkFailed_one: "Auftrag angelegt, konnte aber nicht zur Anfrage hinzugefügt werden. Versuchen Sie es erneut.",
  missingInspectionBody: "Gehen Sie zurück und öffnen Sie die Inspektion erneut.",
  partialCreatedTitle: "Einige Aufträge wurden nicht angelegt",
suggestedJobA11y: "Vorgeschlagener Arbeitsauftrag {{title}}",
findingsCount_one: "{{count}} Befund",
findingsCount_other: "{{count}} Befunde",
missingTitleOrCategory: "Fehlt: Titel oder Kategorie",
editSuggestedJobTitle: "Vorgeschlagenen Arbeitsauftrag bearbeiten",
titlePlaceholderRepairPipe: "z.B. Undichtes Rohr reparieren",
scopeOfWorkPlaceholder: "Arbeitsumfang",
whereJobCarriedOutPlaceholder: "Wo wird dieser Arbeitsauftrag ausgeführt?",
assignToRecommendedA11y: "{{name}} zuweisen",
suggestedAssigneeLabel: "Vorgeschlagen: {{name}} · {{rationale}}",
workPathLabel: "Arbeitspfad",
missingInspection: "Fehlende Inspektion",
loadingEllipsis: "Wird geladen…",
accessRestrictedTitle: "Zugriff eingeschränkt",
accessRestrictedBody: "Nur der Inspektionsersteller oder ein Mitglied des Anlagenteams kann Arbeitsaufträge aus diesen fehlgeschlagenen Elementen erstellen.",
accessDeniedAlertTitle: "Zugriff verweigert",
accessDeniedAlertBody: "Nur der Ersteller der Inspektion oder das Anlagenteam kann diese Arbeitsaufträge erstellen.",
selectSuggestedJobsTitle: "Wählen Sie vorgeschlagene Arbeitsaufträge aus",
selectSuggestedJobsBody: "Wählen Sie mindestens einen Vorschlag zum Erstellen aus.",
missingDetailsBodySuggest: "Bei einigen ausgewählten Vorschlägen fehlt der Titel oder die Kategorie. Bearbeiten Sie diese Karten, bevor Sie Arbeitsaufträge erstellen.",
jobsAlreadyCreated: "Arbeitsaufträge bereits erstellt",
noSuggestedJobs: "Keine empfohlenen Arbeitsaufträge",
allFindingsLinkedBody: "Für jeden fehlgeschlagenen oder als Reparatur gekennzeichneten Befund dieser Inspektion ist bereits ein Arbeitsauftrag verknüpft.",
noFailedItemsBody: "Diese Inspektion enthält derzeit keine fehlerhaften oder als Reparatur markierten Elemente, die einen Folgearbeitsauftrag erfordern.",
openReport: "Bericht öffnen",
linkedJobsTitle: "Verknüpfte Arbeitsaufträge",
linkedJobsHintCannotRecreate: "Diese Ergebnisse sind bereits mit Arbeitsaufträgen verknüpft und können nicht erneut erstellt werden, es sei denn, der Arbeitsauftrag wird gelöscht.",
assetFallback: "Anlage",
suggestionsCountPill_one: "{{count}} Vorschlag",
suggestionsCountPill_other: "{{count}} Vorschläge",
fromFailedItemsPill_one: "aus {{count}} fehlgeschlagenen Prüfpunkt",
fromFailedItemsPill_other: "aus {{count}} fehlgeschlagenen Prüfpunkten",
alreadyCreatedTitle: "Bereits erstellt",
linkedFindingsHint_one: "{{count}} Befund hat bereits verknüpfte Arbeitsaufträge und wird nicht erneut vorgeschlagen.",
linkedFindingsHint_other: "{{count}} Befunde haben bereits verknüpfte Arbeitsaufträge und werden nicht erneut vorgeschlagen.",
followUpJobsFromMarkedItems: "Aufträge aus fehlgeschlagenen Punkten",
aiDraftedHint: "KI-Entwurf. Wählen Sie ab, was kein Auftrag werden soll.",
ruleBasedHint: "Wählen Sie ab, was kein Auftrag werden soll.",
progressLinkNeedsAttention: "Nicht zur Anfrage hinzugefügt",
progressLinkMessage: "Der Arbeitsauftrag wurde erstellt, aber der gemeinsame Anforderungs-/Berichtsfortschritt wurde nicht aktualisiert. {{message}}",
retryLink: "Erneut versuchen",
stillNotLinkedTitle: "Immer noch nicht verlinkt",
jobCreatedNotLinkedFallback: "Der Arbeitsauftrag wurde erstellt, konnte aber nicht mit dem freigegebenen Fortschrittsdatensatz verknüpft werden.",
unableToLinkJobFallback: "Der Arbeitsauftrag konnte nicht mit der Anfrage verknüpft werden.",
missingDetailsBanner_one: "{{count}} ausgewählter Vorschlag benötigt einen Titel oder eine Kategorie, bevor Arbeitsaufträge erstellt werden können. Fähigkeiten werden empfohlen, sind für vorgeschlagene Arbeitsaufträge jedoch optional.",
missingDetailsBanner_other: "{{count}} ausgewählte Vorschläge benötigen einen Titel oder eine Kategorie, bevor Arbeitsaufträge erstellt werden können. Fähigkeiten werden empfohlen, sind für vorgeschlagene Arbeitsaufträge jedoch optional.",
createJobsA11y_one: "{{count}} vorgeschlagenen Arbeitsauftrag erstellen",
createJobsA11y_other: "{{count}} vorgeschlagene Arbeitsaufträge erstellen",
creatingEllipsisEn: "Erstellen...",
createJobsButton_one: "{{count}} Arbeitsauftrag erstellen",
aiDraft: {
  button: "Mit KI entwerfen",
  again: "Erneut mit KI entwerfen",
  notEnough: "Nicht genug KI-Guthaben",
  failedTitle: "KI-Entwurf hat nicht funktioniert",
  failedBody: "Ihre Liste ist unverändert. Bitte versuchen Sie es erneut.",
},
createAndAssignButton_one: "{{count}} Auftrag anlegen und zuweisen",
createAndAssignButton_other: "{{count}} Aufträge anlegen und zuweisen",
approvedBy: "Freigegeben von {{name}}",
handOverIncompleteTitle: "Angelegt, nicht alle übergeben",
handOverIncompleteBody: "Die Aufträge existieren, aber diese wurden nicht übergeben oder der Auftragnehmer wurde nicht benachrichtigt: {{names}}. Öffnen Sie jeden Auftrag, um fertigzustellen.",
createJobsButton_other: "{{count}} Arbeitsaufträge erstellen",
},
shareScreen: {
  askApproveSuggested_other: "Auch um Genehmigung von {{count}} vorgeschlagenen Reparaturen bitten",
  askApproveSuggested_one: "Auch um Genehmigung von {{count}} vorgeschlagenen Reparatur bitten",
  askApproveSuggestedHint: "Jede kann einzeln genehmigt oder abgelehnt werden.",
  relationshipChangeA11y: "Beziehung zum Objekt ändern",
  relationshipChange: "Ändern",
  relationship: "Beziehung: {{role}}",
  greetingTemplateRepairs: "Hallo,\n\nhier ist der Inspektionsbericht für {{assetName}}. Öffnen Sie den Link, lesen Sie ihn und tippen Sie bei jeder vorgeschlagenen Reparatur, die Sie nicht möchten, auf Ablehnen. Unterschreiben Sie dann, um abzuzeichnen – oder tippen Sie auf Zurücksenden, um Änderungen anzufordern.\n\nVielen Dank.",
greetingTemplate: "Hallo,\n\nhier ist der Inspektionsbericht für {{assetName}}. Öffnen Sie den Link, lesen Sie ihn und unterschreiben Sie dann, um abzuzeichnen – oder tippen Sie auf Zurücksenden, um Änderungen anzufordern.\n\nVielen Dank.",
assetFallback: "Ihre Anlage",
emailNotSent: "Geteilt, aber die E-Mail wurde nicht gesendet. Kopieren Sie den Link, um ihn selbst zu versenden.",
copyLink: "Link kopieren",
shareCreatedTitle: "Freigabe erstellt",
shareThisLinkBody: "Teilen Sie diesen Link:\n{{link}}",
inspectionNotFound: "Inspektion nicht gefunden.",
contactNeedsEmail: "Fügen Sie die E-Mail-Adresse hinzu, um den Bericht per E-Mail zu senden.",
checkEmailAddress: "Prüfen Sie die E-Mail-Adresse: sie sieht nicht gültig aus.",
checkPhoneNumber: "Überprüfen Sie die Telefonnummer: Geben Sie eine gültige Nummer für das ausgewählte Land ein oder lassen Sie das Feld leer.",
reportResentNotify: "Bericht erneut gesendet. Sie werden bei einer Antwort benachrichtigt.",
reportSharedNotify: "Bericht gesendet. Die Person erhält eine E-Mail mit Link, und Sie werden bei einer Antwort benachrichtigt.",
createShareFailedFallback: "Die Freigabe konnte nicht erstellt werden.",
errorTitle: "Fehler",
requiredTitle: "Erforderlich",
enterEmailRequired: "Bitte geben Sie eine E-Mail-Adresse ein (oder wählen Sie einen Kontakt mit einer E-Mail-Adresse aus).",
recipientFallback: "Empfänger",
contactFallback: "Kontakt",
selectContactTitle: "Wählen Sie einen Kontakt aus",
selectContactBody: "Das Teilen erfolgt kontaktbasiert. Tippen Sie bitte auf „Kontakt auswählen“ und wählen Sie einen Kontakt aus oder fügen Sie ihn hinzu, mit dem Sie ihn teilen möchten.",
respondByLine: "Bitte antworten Sie bis {{date}}\n\n",
estimatedTotalLine: "Geschätzte Gesamtsumme: {{amount}}\n\n",
reviewLinkLine: "Prüflink: {{link}}",
assetFallbackShort: "Anlage",
emailSubject: "Inspektionsbericht – {{assetName}}",
resentTitle: "Erneut gesendet",
sentTitle: "Gesendet",
resentBody: "Inspektionsbericht erneut an den Empfänger gesendet.",
sentBody: "Inspektionsbericht geteilt. Der Empfänger wird benachrichtigt.",
deliveryUnconfirmed: "Die Freigabe wurde erstellt, die Lieferung konnte jedoch nicht bestätigt werden. Teilen Sie diesen Link manuell:\n{{link}}",
inspectionNotFoundPlain: "Inspektion nicht gefunden",
onlyCreatorAssigneeOrTeamCanShare: "Nur der Ersteller dieser Inspektion, der ihr zugewiesene Inspektor oder ein Mitglied des Anlagenteams kann den Bericht teilen.",
shareLinkNotConfiguredProd: "Für diesen Arbeitsbereich ist noch kein gemeinsam nutzbarer Weblink eingerichtet, sodass Empfänger den Berichtslink möglicherweise nicht öffnen können. Bitte wenden Sie sich an Ihren Administrator.",
reviewAssistantTitle: "Prüfassistent",
sending: "Wird gesendet…",
resendReportTo: "Bericht erneut an {{name}} senden",
sendReportTo: "Bericht an {{name}} senden",
theRequesterFallback: "der Antragsteller",
oneTapHint: "Aus der Anfrage übernommen. Ändern Sie unten bei Bedarf die Person oder die Nachricht.",
shareTo: "Senden an",
contactsHint: "Tippen Sie auf Kontakt auswählen und wählen Sie die Person. Personen, an die Sie ihn schon gesendet haben, stehen oben.",
whoCanOpen: "Nur diese Person kann den Bericht öffnen. Der Link in ihrer E-Mail meldet sie direkt an. Wer den Link sonst bekommt, kann Sie nur um Zugriff bitten.",
changeContact: "Kontakt ändern",
selectContact: "Kontakt auswählen",
primaryChooseRole: "Rolle wählen",
primaryAddEmail: "E-Mail hinzufügen",
primaryResend: "Erneut senden",
primarySend: "Bericht senden",
noEmailOrPhone: "Keine E-Mail oder Telefon",
shareToContactTitle: "Senden an",
howToSend: "So senden Sie",
byEmail: "Per E-Mail",
roleLabel: "Rolle *",
recipientNameOptional: "Name der Person (optional)",
recipientNamePlaceholder: "z.B. John Smith",
recipientEmailLabel: "E-Mail-Adresse *",
recipientEmailA11y: "E-Mail-Adresse (Pflichtfeld)",
recipientEmailPlaceholder: "client@example.com",
phoneOptional: "Telefon (optional)",
shareStatus: "Bereits gesendet",
firstSharedLabel: "Bereits gesendet am {{date}}",
lastResharedLabel: "Erneut gesendet am {{date}}",
noResponseByDeadline: "Keine Antwort bis zum festgelegten Datum. Tippen Sie auf Erneut senden, um zu erinnern.",
responseDeadlineOptional: "Antwort bis (optional)",
messageOptional: "Nachricht (optional)",
messagePlaceholder: "Fügen Sie eine Notiz für den Empfänger hinzu...",
includeSuggestedJobsTitle: "Nehmen Sie vorgeschlagene Arbeitsaufträge in die gemeinsame Überprüfung auf",
includeSuggestedJobsHint_one: "Fügt {{count}} vorgeschlagenes Folgeelement zur Genehmigung durch den Empfänger hinzu.",
includeSuggestedJobsHint_other: "Fügt {{count}} vorgeschlagene Folgeelemente zur Genehmigung durch den Empfänger hinzu.",
missingEstimateWarning_one: "{{count}} Element hat keinen Kostenvoranschlag – es wird trotzdem im Bericht aufgeführt, nur ohne Kosten. Sie können jetzt teilen oder zuerst Schätzungen hinzufügen.",
missingEstimateWarning_other: "{{count}} Elemente haben keinen Kostenvoranschlag – sie werden trotzdem im Bericht aufgeführt, nur ohne Kosten. Sie können jetzt teilen oder zuerst Schätzungen hinzufügen.",
couldNotShareReportTitle: "Bericht konnte nicht geteilt werden",
sharingFailedFallback: "Freigabe fehlgeschlagen. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
reportScreen: {
  exportFailed: {
    word: "Word-Datei konnte nicht erstellt werden. Versuchen Sie es erneut.",
    excel: "Excel-Datei konnte nicht erstellt werden. Versuchen Sie es erneut.",
    pdf: "PDF konnte nicht erstellt werden. Versuchen Sie es erneut.",
  },
  exportPreparing: {
    word: "Word-Datei wird erstellt…",
    excel: "Excel-Datei wird erstellt…",
    pdf: "PDF wird erstellt…",
  },
editRepairDetailsTitle: "Reparaturdetails bearbeiten",
saveFailedFallback: "Speichern fehlgeschlagen.",
titleLabel: "Titel",
titlePlaceholder: "z.B. Undichten Wasserhahn reparieren",
categoryLabel: "Kategorie",
descriptionLabel: "Beschreibung",
descriptionPlaceholder: "Was muss getan werden...",
priorityLabel: "Priorität",
dueDateOptional: "Fälligkeitsdatum (optional)",
estimatedCostOptional: "Geschätzte Kosten (optional)",
estimatedCostA11y: "Geschätzter Kostenbetrag",
visibilityLabel: "Sichtbarkeit",
saveRepairFailedTitle: "Reparatur konnte nicht gespeichert werden",
syncFailedGeneric: "Synchronisierung fehlgeschlagen.",
skipped: "Übersprungen",
downloadPdf: "PDF herunterladen",
downloadExcel: "Excel herunterladen",
downloadWord: "Word herunterladen",
sharePdfToGoogleDrive: "PDF auf Google Drive teilen…",
shareExcelToOneDrive: "Excel auf OneDrive teilen…",
shareWordToSharePoint: "Word mit SharePoint teilen…",
googleDrive: "Google Drive",
oneDrive: "OneDrive",
sharePoint: "SharePoint",
shareRequiredTitle: "Teilen Sie zuerst den Bericht",
shareRequiredBody: "Tippen Sie auf Teilen und wählen Sie, für wen er ist. So entsteht der Link zum Lesen und Antworten.",
hostedLinkCopiedTitle: "Prüflink kopiert",
inspectionReportFileLabel: "Inspektionsbericht ({{format}})",
exportFileError: "Exportdatei konnte nicht generiert werden.",
exportReadyTitle: "Export bereit",
exportReadyBody: "Der Download Ihrer Datei wurde gestartet.",
reportInsightTitle: "Einblick in den Bericht",
reviewRepairEvidenceAction: "Überprüfen Sie die Reparaturnachweise und die geschätzten Kosten vor dem Export.",
shareReportAction: "Tippen Sie auf Teilen, um einen Link zum Lesen und Beantworten des Berichts zu senden.",
runFirstExportAction: "Tippen Sie auf Herunterladen, um eine PDF-, Excel- oder Word-Kopie mit Ihrem Logo zu speichern.",
itemsVisible_one: "{{count}} Prüfelement ist im Bericht sichtbar.",
itemsVisible_other: "{{count}} Prüfelemente sind im Bericht sichtbar.",
repairFindingsIncluded_one: "{{count}} Reparaturbefund ist enthalten.",
repairFindingsIncluded_other: "{{count}} Reparaturbefunde sind enthalten.",
noRepairFindingsIncluded: "Es sind keine Reparaturbefunde enthalten.",
hostedLinkAvailable: "Ein Prüflink ist versandbereit.",
hostedLinkNotAvailable: "Noch kein Prüflink. Tippen Sie auf Teilen, um einen zu erstellen.",
exportRecords_one: "{{count}} aktueller Exportdatensatz vorhanden.",
exportRecords_other: "{{count}} aktuelle Exportdatensätze vorhanden.",
noExportActivity: "Noch niemand hat diesen Bericht heruntergeladen.",
metricInspected: "Geprüft",
metricRepairs: "Reparaturen",
metricExports: "Exporte",
metricSummary: "Übersicht",
summaryReady: "Bereit",
summaryMissing: "Fehlt",
insightSourceLabel: "die Punkte und Reparaturen dieser Inspektion",
nextSteps: "Nächste Schritte",
copyHostedReportLink: "Prüflink kopieren",
brandingSettings: "Branding-Einstellungen",
moreReportOptionsA11y: "Weitere Berichtsoptionen",
yourSignOff: "Ihre Freigabe",
signOff: "Abnehmen",
reviewAndSignOff: "Genehmigen oder zurücksenden",
shareA11y: "Teilen",
share: "Teilen",
assignedTo: "Zugewiesen an {{name}}",
unassigned: "Nicht zugewiesen",
quoteAwarded: "Angebot beauftragt",
quoteRequested: "Angebot angefordert",
quotes: "Angebote",
jobsCreated_one: "{{count}} Arbeitsauftrag erstellt",
jobsCreated_other: "{{count}} Arbeitsaufträge erstellt",
findingsMayNeedJobs_one: "{{count}} Befund benötigt möglicherweise Arbeitsaufträge",
findingsMayNeedJobs_other: "{{count}} Befunde benötigen möglicherweise Arbeitsaufträge",
noRepairFindingsInReport: "Keine Reparaturbefunde in diesem Bericht",
createJobsFromFindingsA11y: "Aufträge aus den Befunden bestätigen",
createJobsFromFindings: "Aufträge bestätigen",
openLinkedJobsA11y: "Verknüpfte Arbeitsaufträge öffnen",
openLinkedJobs_one: "Verknüpften Auftrag öffnen",
openLinkedJobs_other: "Verknüpfte Arbeitsaufträge öffnen",
approved: "Abgezeichnet",
awaitingApproval: "Wartet auf Abzeichnung",
approvedBy: "Abgezeichnet von {{name}}",
recipientFallback: "Empfänger",
approvedOnAt: " am {{date}} um {{time}}",
reviewRequested: "Prüfung angefordert",
sharedWithName: "Geteilt mit {{name}}",
reviewRequestedFallback: "Prüfung angefordert",
firstShared: "Zuerst geteilt {{date}}",
lastReshared: " | Zuletzt erneut geteilt {{date}}",
resendAndUpdateDeadline: "Erneut senden & Frist anpassen",
noReviewRequestedYet: "Es wurde noch keine Prüfung angefordert.",
notSharedYetPrefix: "Noch nicht geteilt – mit ",
shareAboveLink: "Teilen (oben)",
notSharedYetSuffix: " können Sie eine Prüfung anfordern.",
theInspectorFallback: "der Inspektor",
askInspectorEmptyHint: "Fragen Sie den Inspektor nach diesem Bericht. Noch keine Nachrichten.",
discussInspectionEmptyHint: "Besprechen Sie diese Inspektion mit dem Gutachter. Noch keine Nachrichten.",
atAGlance: "Auf einen Blick",
estTotal: "Geschätzte Summe",
approvalLabel: "Abzeichnung",
approvalAwaiting: "Ausstehend",
jobsLabel: "Aufträge",
recentExports: "Aktuelle Exporte",
loadingExportHistory: "Exportverlauf wird geladen...",
noExportsRecorded: "Für diesen Bericht wurden noch keine Exporte erfasst.",
loadErrorTitle: "Dieser Bericht konnte nicht geladen werden",
goBack: "Zurück",
reportAvailableWhenCompleted: "Bericht verfügbar, wenn die Inspektion abgeschlossen ist.",
findingsAndEvidence: "Erkenntnisse und Nachweise",
noItemsRecorded: "Für diese Inspektion wurden keine Prüfpunkte erfasst.",
otherGroup: "Sonstiges",
inspectorNotes: "Inspektornotizen",
noteLabel: "Notiz",
itemSkippedFallback: "Dieses Element wurde bei der Inspektion übersprungen.",
mediaCount: "Medien · {{count}}",
playVideo: "Video {{index}} abspielen",
repairAndRemediation: "Reparatur und Sanierung",
descriptionOrRecommendation: "Beschreibung",
recommendation: "Empfehlung",
labourAndMaterials: "Arbeit und Materialien",
urgentFallback: "Dringend",
requiredSkills: "Erforderliche Fähigkeiten",
dueDate: "Fälligkeitsdatum",
estimatedCost: "Geschätzte Kosten",
urgentRepairNote: "Dringender Reparaturhinweis",
urgentRepairNoteFallback: "Dieser Punkt wurde als dringend handlungsbedürftig gekennzeichnet.",
jobCreated: "Auftrag erstellt",
jobsCreatedPlain: "Erstellte Aufträge",
editRepairDetails: "Reparaturdetails bearbeiten",
whereThisStands: "Aktueller Stand",
reportOptionsTitle: "Berichtsoptionen",
couldNotLoadImageSubtext: "Das Bild wurde möglicherweise verschoben oder ist nicht verfügbar.",
syncReportWorkspaceFailedTitle: "Datei konnte nicht erstellt werden",
statusPrefix: "Status: {{status}}",
templateVersionLabel: "Checkliste: {{name}}{{version}}",
conductedInspection: "Durchgeführte Inspektion",
inspectorFallback: "Inspektor",
},
convertScreen: {
  missingShareBody: "Öffnen Sie dies aus dem Inspektionsbericht, um genehmigte Reparaturen in Aufträge umzuwandeln.",
  missingShareTitle: "Hier gibt es nichts zu öffnen",
editA11y: "{{title}} bearbeiten",
dueLabel: "Fällig am {{date}}",
missingFieldsHint: "Fehlt: Titel, Kategorie oder erforderliche Fähigkeiten",
editJobDetailsTitle: "Arbeitsauftragsdetails bearbeiten",
requiredTitle: "Erforderlich",
requiredBody: "Titel und Kategorie sind erforderlich.",
titleLabel: "Titel",
titlePlaceholder: "z.B. Undichten Wasserhahn reparieren",
categoryLabel: "Kategorie *",
priorityLabel: "Priorität (optional)",
dueDateLabel: "Fälligkeitsdatum (optional)",
jobLocationLabel: "Arbeitsauftragsort (optional)",
addressSearchPlaceholder: "Adresse suchen…",
estimateLabel: "Kostenvoranschlag (optional)",
costPlaceholder: "0,00",
assigneeLabel: "Zuständige Person (optional)",
noneOption: "Keine",
saving: "Wird gespeichert…",
save: "Speichern",
missingShare: "Fehlende Freigabe",
loading: "Wird geladen...",
noApprovedRepairsTitle: "Keine genehmigten Reparaturen",
noApprovedRepairsBody: "Der Kunde hat noch keine Reparaturen für diese Freigabe genehmigt.",
onlyCreatorOrTeamCanConvert: "Nur der Inspektionsersteller oder ein Mitglied des Anlagenteams kann aus dieser Freigabe Arbeitsaufträge erstellen.",
unsavedJobEditsMessage: "Sie haben nicht gespeicherte Arbeitsauftragsänderungen. Gehen und sie verlieren?",
leave: "Verlassen",
keepEditing: "Bearbeiten Sie weiter",
createJobsErrorTitle: "Aufträge konnten nicht angelegt werden",
createJobsErrorFallback: "Arbeitsaufträge konnten nicht erstellt werden.",
selectRepairsTitle: "Reparaturen auswählen",
selectRepairsBody: "Wählen Sie mindestens eine genehmigte Reparatur aus (aktivieren Sie das Kontrollkästchen auf jeder Karte). Tippen Sie vor dem Erstellen auf eine Karte, um Titel, Kategorie oder Beauftragten zu bearbeiten.",
missingDetailsTitle: "Fehlende Details",
missingDetailsBody: "Bei einigen ausgewählten Reparaturen fehlen Titel, Kategorie oder erforderliche Fähigkeiten. Tippen Sie auf jede Karte, um sie zu bearbeiten, bevor Sie Arbeitsaufträge erstellen.",
step1WorkPath: "Wer erledigt die Arbeit?",
step1WorkPathHint: "Wählen Sie Ihr Team, einen Auftragnehmer oder fordern Sie Angebote an. Die Personen wählen Sie, nachdem die Aufträge angelegt sind.",
step2SelectItems: "Welche Reparaturen brauchen einen Auftrag?",
creatingJobs: "Wird erstellt…",
createJobs_one: "{{count}} Arbeitsauftrag erstellen",
createJobs_other: "{{count}} Arbeitsaufträge erstellen",
},
completeScreen: {
  approvedToast: "Inspektion abgezeichnet. Teilen Sie den Bericht oder wählen Sie Fertig.",
  alerts: {
    optionalBody_other: "{{count}} optionale Punkte sind weder beantwortet noch übersprungen. Trotzdem abschließen?",
    optionalBody_one: "{{count}} optionaler Punkt ist weder beantwortet noch übersprungen. Trotzdem abschließen?",
    failedTitle_other: "{{count}} fehlgeschlagene Punkte haben kein Foto und keine Notiz",
    failedTitle_one: "{{count}} fehlgeschlagener Punkt hat kein Foto und keine Notiz",
    requiredBody_other: "Beantworten oder überspringen Sie {{count}} Pflichtpunkte, bevor Sie diese Inspektion abschließen.",
    requiredBody_one: "Beantworten oder überspringen Sie {{count}} Pflichtpunkt, bevor Sie diese Inspektion abschließen.",
    completedToast: "Inspektion abgeschlossen",
    optionalTitle: "Unbeantwortete Punkte",
    goToFailed: "Zum fehlgeschlagenen Punkt",
    failedBody: "Fügen Sie ein Foto oder eine Notiz hinzu, damit andere das Problem sehen, oder schließen Sie so ab.",
    jumpToFirst: "Zum ersten springen",
    requiredTitle: "Pflichtpunkte nicht erledigt",
    tryAgain: "Erneut versuchen",
    savingBody: "Sie bleiben auf diesem Gerät. Tippen Sie auf Erneut versuchen und schließen Sie dann die Inspektion ab.",
    savingTitle: "Einige Antworten sind noch nicht gespeichert",
    conflictChoose: "Auswählen",
    conflictBody: "Wählen Sie „Meine Antworten behalten“ oder „Andere Version übernehmen“ und schließen Sie dann ab.",
    conflictTitle: "Jemand anderes hat diese Inspektion geändert",
  },
  status: {
    nextVisit: "Nächster Besuch fällig am {{date}}.",
    requesterWaiting: "Die anfragende Person wartet auf diesen Bericht.",
    sentTo: "Zur Genehmigung an {{name}} gesendet.",
    approveSelf: "Prüfen Sie die Befunde und tippen Sie dann auf Abzeichnen.",
    approveOrLeave: "Zeichnen Sie sie selbst ab oder überlassen Sie das {{name}}.",
  },
  actions: {
    approve: "Abzeichnen",
    createCertificate: "Erneuertes Zertifikat ausstellen",
    shareRequester: "Bericht mit der anfragenden Person teilen",
    createApprovedJobs: "Genehmigte Aufträge anlegen",
    scheduleNext: "Nächste Inspektion planen",
    shareReport: "Bericht teilen",
    exportReport: "Bericht exportieren",
    report: "Bericht",
    done: "Fertig",
    confirmJobs: "Aufträge bestätigen",
  },
loadErrorTitle: "Diese Inspektion konnte nicht geladen werden",
loadErrorDescription: "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
notFoundTitle: "Inspektion nicht gefunden",
notFoundDescription: "Diese Inspektion wurde möglicherweise entfernt oder der Link ist veraltet.",
goBack: "Zurück",
notCompletedYet: "Diese Inspektion ist noch nicht abgeschlossen.",
back: "Zurück",
generateSummaryError: "Die Inspektionszusammenfassung konnte nicht generiert werden. Bitte versuchen Sie es erneut.",
saveSummaryError: "Die Inspektionszusammenfassung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
reopenErrorTitle: "Konnte nicht erneut geöffnet werden",
reopenErrorFallback: "Bitte erneut versuchen.",
jobFollowUpTitle: "{{name}} – Folgeauftrag",
jobFollowUpDescription: "Nacharbeit aus der Inspektion {{checklist}} an {{assetName}}, {{date}}.",
assetFallback: "Anlage",
templateFallback: "Inspektion",
certificateTitle: "{{name}}-Zertifikat",
cannotCreateCertificateTitle: "Zertifikat kann nicht erstellt werden",
cannotCreateCertificateBody: "Diese Inspektion ist nicht mit einer Anlage verknüpft.",
certificateCreatedTitle: "Zertifikat erstellt",
certificateCreatedBody: "Zertifikat in den Dokumenten der Anlage gespeichert.",
errorTitle: "Zertifikat konnte nicht erstellt werden",
certificateCreateError: "Zertifikat konnte nicht erstellt werden.",
inspectedLabel: "Geprüft",
failedItemsLabel: "Fehlgeschlagene Elemente",
followUpJobsLabel: "Vorgeschlagene Aufträge",
inspectionAssistantTitle: "Prüfassistent",
confirmNextActions: "Wie es weitergeht",
moreCompletionActions: "Mehr",
moreCompletionActionsSummary: "Auftrag manuell anlegen, Inspektion wieder öffnen oder Bericht teilen.",
createJobNow: "Auftrag jetzt erstellen",
notifyTeam: "Team benachrichtigen",
syncFailedTitle: "Zusammenfassung konnte nicht gespeichert werden",
syncFailedFallback: "Anfrage fehlgeschlagen. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
templateCard: {
allAssetTypes: "Alle Anlagentypen",
categoryGeneral: "Allgemein",
categoriesCount_one: "{{count}} Kategorie",
categoriesCount_other: "{{count}} Kategorien",
usedCount_zero: "Noch nicht verwendet",
usedCount_one: "Einmal verwendet",
usedCount_other: "{{count}}-mal verwendet",
createdDate: "Erstellt {{date}}",
allTeams: "Alle Teams",
selectedTeams: "Ausgewählte Teams",
},
checklistCard: {
allTypes: "Alle Typen",
shared: "Geteilt",
totalItems: "Punkte gesamt",
required: "Erforderlich",
optional: "Optional",
usedTimes_one: "{{count}}-mal verwendet",
usedTimes_other: "{{count}}-mal verwendet",
completedCount_one: "{{count}} abgeschlossen",
completedCount_other: "{{count}} abgeschlossen",
estMinutes: "~{{count}} min",
createdDate: "Erstellt {{date}}",
},
conditionalEditor: {
showOnlyWhen: "Nur anzeigen, wenn",
addPreviousItemFirst: "Fügen Sie zuerst ein vorheriges Element hinzu, um dies bedingt zu machen.",
parentItem: "Übergeordnetes Element",
untitledItem: "Punkt ohne Titel",
alwaysShown: "Wird immer angezeigt",
expectedAnswer: "Erwartete Antwort",
notConditional: "Nicht bedingt",
clearCondition: "Bedingung entfernen",
onlyShownWhen: "Wird nur angezeigt, wenn „{{parent}}“ gleich {{value}} ist.",
conditionInvalidAfterReorder: "Die aktuelle Bedingung ist nach dem Neuanordnen nicht mehr gültig. Wählen Sie einen früheren Punkt aus oder entfernen Sie die Bedingung.",
itemAlwaysShown: "Dieser Punkt wird immer angezeigt.",
},
card: {
awaitingReviewerResponse: "Warten auf die Antwort der prüfenden Person",
inspectorFallback: "Inspektor",
recipientFallback: "Empfänger",
sharePendingCount_one: "{{count}} ausstehend",
sharePendingCount_other: "{{count}} ausstehend",
shareDeclinedCount_one: "{{count}} abgelehnt",
shareDeclinedCount_other: "{{count}} abgelehnt",
shareApprovedCount_one: "{{count}} genehmigt",
shareApprovedCount_other: "{{count}} genehmigt",
sharedWith: "Geteilt mit {{names}}",
responseDue: "Antwort fällig {{date}}",
templateFallback: "Inspektion",
assetFallback: "Unbekannte Anlage",
inspectorA11y: "Inspektor {{name}}",
issuesCountA11y_one: "{{count}} Problem",
issuesCountA11y_other: "{{count}} Probleme",
repairsCountA11y_one: "{{count}} Reparatur",
repairsCountA11y_other: "{{count}} Reparaturen",
urgentCountA11y_one: "{{count}} dringend",
urgentCountA11y_other: "{{count}} dringend",
openAssetA11y: "Öffnen Sie die Anlage {{assetName}}",
urgentPill: "Dringend {{count}}",
issuesPill: "Probleme {{count}}",
repairsPill: "Reparaturen {{count}}",
awaitingApproval: "Warten auf Genehmigung",
sharedDense: "Geteilt",
reportShared: "Bericht geteilt",
},
noteSuggestions: {
suggestions: "Vorschläge",
tapToInsert: "Zum Einfügen antippen",
findingRecentNotes: "Letzte Notizen werden gesucht…",
},
/** The runner's item controls, footer and summary line (were English literals). */
runner: {
  skipGroupBody_other: "{{count}} Punkte dieser Gruppe als übersprungen markieren und zur nächsten Gruppe wechseln?",
  skipGroupBody_one: "{{count}} Punkt dieser Gruppe als übersprungen markieren und zur nächsten Gruppe wechseln?",
  syncUnsavedBanner: "Eine Änderung wurde nicht gespeichert. Tippen, um es erneut zu versuchen.",
  syncFailedBanner: "Einige Antworten sind noch nicht gespeichert. Sie bleiben auf diesem Gerät. Tippen, um es erneut zu versuchen.",
  tryAgain: "Bitte versuchen Sie es erneut.",
  moveToItemTitle: "Sprung zu diesem Punkt nicht möglich",
  captureUnsupported: "Diese Art von Aufnahme kann nicht in einem Punkt gespeichert werden.",
  captureScanBody: "QR-Codes werden vom Scanner gelesen, nicht in Punkten gespeichert.",
  captureScanTitle: "QR-Codes mit dem Scanner lesen",
  captureMeasurementAdded: "Messwert zur Notiz des Punkts hinzugefügt.",
  captureMeasurement: "Messwert: {{value}}",
  captureNoteAdded: "Notiz zum Punkt hinzugefügt.",
  capturePhotoAdded: "Foto zum Punkt hinzugefügt.",
  captureNoNote: "Es wurde keine Notiz erfasst.",
  captureNoPhoto: "Es wurde kein Foto aufgenommen.",
  capturePhotosOff: "Für diesen Punkt sind keine Fotos vorgesehen.",
  captureNoItem: "Öffnen Sie zuerst einen Punkt und nehmen Sie dann erneut auf.",
  captureMismatch: "Diese Aufnahme gehört zu einer anderen Inspektion.",
  captureNotFound: "Diese Aufnahme wurde nicht gefunden. Nehmen Sie sie erneut auf.",
  captureNotSavedTitle: "Aufnahme nicht gespeichert",
  skipGroupReason: "Gruppe trifft nicht zu",
  skipGroupConfirm: "Gruppe überspringen",
  skipGroupTitle: "Diese Gruppe überspringen?",
  keysClose: "Dieses Feld schließen",
  keysToggle: "Dieses Feld ein- oder ausblenden",
  keysSkip: "Offenen Punkt überspringen",
  keysYesNo: "Ja / Nein antworten (offener Punkt)",
  keysRate: "Bestanden / Nicht bestanden / Entfällt (offener Punkt)",
  keysPrevNext: "Vorheriger / nächster Punkt oder Gruppe",
  timelineStatusScheduled: "Geplant",
  timelineStatusCreated: "Erstellt",
  timelineAutomatic: "Automatisch",
  timelineUpdated: "Zuletzt aktualisiert",
  timelineCancelled: "Inspektion abgebrochen",
  timelineApproved: "Bericht genehmigt",
  timelineCompleted: "Inspektion abgeschlossen",
  timelineResumeScheduled: "Fortsetzung geplant",
  timelinePaused: "Inspektion pausiert",
  timelineStarted: "Inspektion begonnen",
  timelineCreated: "Inspektion erstellt",
  exportReport: "Bericht exportieren",
  report: "Bericht",
  askAiDescription: "Hilfe bei den nächsten Prüfungen, basierend auf Ihren bisherigen Antworten.",
  askAiTooltip: "KI kann bei den nächsten Prüfungen helfen",
  askAi: "KI fragen",
  saveAndExit: "Speichern und schließen",
  savedFindInWork: "Gespeichert. Sie finden sie unter Arbeit › Meine, um weiterzumachen.",
  delete: "Löschen",
  deleteBody: "Das kann nicht rückgängig gemacht werden.",
  deleteTitle: "Diese Inspektion löschen?",
  allItemsDone: "Alle Punkte erledigt. Tippen Sie auf Inspektion abschließen.",
  sharedReportHint: "Wenn jemand einen Bericht mit Ihnen geteilt hat, öffnen Sie den Link in der E-Mail. Unter Aktivität finden Sie auch Berichte, die auf Sie warten.",
  requester: "Anfragende Person",
  fromRequest: "Aus einer Anfrage",
  unknownStatus: "Unbekannt",
  itemsHidden: "{{total}} Punkte treffen nicht mehr zu und werden ausgeblendet.",
  itemHiddenOne: "„{{label}}“ trifft nicht mehr zu und wird ausgeblendet.",
  addNoteFirstBody: "Geben Sie eine kurze Notiz ein und tippen Sie dann auf Verfeinern.",
  addNoteFirstTitle: "Zuerst eine Notiz hinzufügen",
  signInVideos: "Melden Sie sich an, um Videos hinzuzufügen.",
  signInPhotos: "Melden Sie sich an, um Fotos hinzuzufügen.",
  signInTitle: "Anmeldung erforderlich",
  recordVideo: "Video aufnehmen oder auswählen",
  takePhoto: "Foto aufnehmen oder auswählen",
  polishFailedTitle: "Text konnte nicht verfeinert werden",
  polishedTitle: "Verfeinerter Text",
  discard: "Verwerfen",
  editDraft: "Bearbeiten",
  accept: "Übernehmen",
  revert: "Rückgängig",
  draftNoteTitle: "Notizentwurf für {{label}}",
  previousInspection: "Vorherige Inspektion",
  previousRating: "Vorher: {{rating}}",
  previousNote: "Letztes Mal: {{note}}",
  videoOfA11y: "Video {{index}} von {{total}}",
  photoOfA11y: "Foto {{index}} von {{total}}",
  expandDetails: "Details einblenden",
  collapseDetails: "Details ausblenden",
  collapsed: "zugeklappt",
  expanded: "aufgeklappt",
  stateNotCompletedShort: "nicht erledigt",
  stateSkippedShort: "übersprungen",
  stateCompletedShort: "erledigt",
  itemHeaderA11y: "{{label}}, {{state}}, {{expanded}}",
  stateNotCompleted: "Nicht erledigt",
  stateCompleted: "Punkt erledigt",
  stateSkipped: "Übersprungen",
  followUpAddA11y: "Nacharbeit für {{label}} hinzufügen",
  followUpEditA11y: "Nacharbeit für {{label}} bearbeiten",
  flaggedNeedsJob: "Markiert. Braucht das einen Auftrag?",
  mediaAddA11y: "Foto oder Video für {{label}} hinzufügen",
  mediaAttachedA11y: "Nachweis für {{label}} hinzufügen, {{total}} angehängt",
  noteAddA11y: "Notiz für {{label}} hinzufügen oder diktieren",
  noteEditA11y: "Notiz für {{label}} bearbeiten",
  note: "Notiz",
  naA11y: "Nicht zutreffend",
  naSub: "Trifft hier nicht zu",
  na: "Entfällt",
  flagSub: "Muss noch einmal geprüft werden",
  flag: "Markieren",
  failSub: "Erfüllt die Kriterien nicht",
  fail: "Nicht bestanden",
  passSub: "Erfüllt die Prüfkriterien",
  pass: "Bestanden",
media: "Medien",
followUp: "Nacharbeit",
followUpProposed: "Auftrag vorgeschlagen",
yesOrNo: "Ja oder Nein",
passFailNa: "Bestanden, Nicht bestanden oder N/A",
passFlagFail: "Bestanden, Markieren oder Nicht bestanden",
level: "Stufe",
conditionRating: "Zustandsbewertung",
stop: "Stopp",
finishing: "Wird abgeschlossen...",
dictate: "Diktieren",
polishing: "Wird verfeinert…",
generating: "Wird erstellt…",
polish: "Verfeinern",
generateDraft: "Entwurf erstellen",
previous: "Zurück",
completeInspection: "Inspektion abschließen",
nextItem: "Nächster Punkt",
lastItem: "Letzter Punkt",
nextGroup: "Nächste Gruppe",
lastGroup: "Letzte Gruppe",
nextUnanswered: "Nächster offener Punkt",
started: "Begonnen {{when}}",
startedBy: "Begonnen {{when}} · {{name}}",
},
viewModel: {
completionHintBlocking: "„Inspektion abschließen“ erscheint, sobald erforderliche Punkte beantwortet oder übersprungen wurden.",
completionHintFinalGroup: "„Inspektion abschließen“ erscheint, wenn Sie die letzte Gruppe erreichen.",
completionHintLastItem: "„Inspektion abschließen“ erscheint beim letzten Punkt.",
completionHintOptionalRemain: "Es sind noch optionale Punkte offen – Sie können abschließen, sobald die Pflichtpunkte erledigt sind.",
},
pendingMedia: {
failedCaption_one: "{{count}} nicht hochgeladen – zum erneuten Versuch tippen",
failedCaption_other: "{{count}} nicht hochgeladen – zum erneuten Versuch tippen",
pendingCaption_one: "{{count}} auf diesem Gerät gespeichert, wartet auf den Upload",
pendingCaption_other: "{{count}} auf diesem Gerät gespeichert, warten auf den Upload",
retryA11y: "Versuchen Sie erneut, diese Aufnahme hochzuladen",
pendingA11y: "Die Aufnahme wurde auf diesem Gerät gespeichert und wartet auf den Upload",
},
sideProgressPanel: {
sections: "Abschnitte",
noSections: "Keine Abschnitte",
general: "Allgemein",
},
findingsReview: {
  notAnswered_other: "{{count}} unbeantwortet",
  notAnswered_one: "{{count}} unbeantwortet",
  failedNeedJob_other: "{{count}} fehlgeschlagene Punkte brauchen einen Auftrag",
  failedNeedJob_one: "{{count}} fehlgeschlagener Punkt braucht einen Auftrag",
reportArchived: "Bericht gespeichert",
findingsNeedDecision_one: "{{count}} fehlgeschlagener Punkt braucht einen Auftrag – oder einen Grund, ihn zu lassen.",
findingsNeedDecision_other: "{{count}} fehlgeschlagene Punkte brauchen einen Auftrag – oder einen Grund, sie zu lassen.",
noFindingsNeedFollowUp: "Keine Befunde, die einer Nachverfolgung bedürfen.",
recommendedWorkPackages_one: "{{count}} Auftrag aus den Befunden vorgeschlagen.",
recommendedWorkPackages_other: "{{count}} Aufträge aus den Befunden vorgeschlagen.",
allClear: "Alle geprüften Punkte sind in Ordnung.",
successfulItemsTitle: "Bestandene Elemente · {{count}}",
successfulItemsSummary: "Elemente, die ohne Aktion bestanden wurden",
notRated: "Nicht bewertet",
answerItem: "Zum Beantworten wieder öffnen",
planWork: "Auftrag bestätigen",
decisionA11y: "{{label}}: {{itemLabel}}",
uncertain: "Nicht beantwortet",
urgentFinding: "Dringender Befund",
failedFinding: "Nicht bestandener Punkt",
},
vision: {
findingsGroup: "Weitere Befunde",
keepWorking: "Weiterarbeiten",
scan: {
group: "Scannen",
item: "Scannen",
groupHint: "Vision kann bei {{count}} von {{total}} Prüfpunkten helfen",
recommendedHint: "Empfohlen: diesen Abschnitt zuerst scannen",
resultsReady: "Ergebnisse bereit",
analysing: "Wird analysiert…",
open: "Scan öffnen",
removeFinding: "Befund entfernen",
supportedByEvidence: "Durch Bildnachweis gestützt",
cameraAssisted: "Mit Kamerahilfe, kein Foto gespeichert",
},
walk: {
  cardActionUpload: "Fotos hinzufügen",
  cardTitleUpload: "Den Raum anhand von Fotos prüfen",
cardTitle: "Mit der Kamera herumgehen",
cardBody: "Vision kann {{count}} von {{total}} Prüfpunkten anhand dessen beantworten, was es sieht, und füllt sie aus. Sie prüfen nur, was es nicht sehen konnte oder wobei es unsicher war.",
cardAction: "Rundgang starten",
howTo: "Tippen Sie auf den roten Knopf, gehen Sie dann langsam herum und halten Sie bei jedem Punkt der Checkliste kurz an.",
walking: "Scannen… gehen Sie langsam und halten Sie bei jedem Punkt an. Tippen Sie auf Fertig, wenn Sie den Rundgang beendet haben.",
start: "Rundgang starten",
stop: "Rundgang pausieren",
uploadTitle: "Fotos aus dem ganzen Raum hinzufügen",
autoFilled: "Für Sie ausgefüllt: {{count}}",
rushedTitle: "Das ging schnell",
rushedBody: "Sie haben {{total}} Punkte in {{taken}} s erfasst. Halten Sie bei jedem etwa 2 Sekunden an (insgesamt etwa {{suggested}} s), damit Vision alles scharf sieht.",
keepScanning: "Weiter scannen",
finishAnyway: "Trotzdem beenden",
slowDown: "Langsamer und das Telefon ruhig halten",
},
capture: {
title: "Scannen",
uploadTitle: "Fotos zum Scannen hinzufügen",
manual: "Manuell beantworten",
moveSlowly: "Machen Sie ein paar klare Fotos von dem, was dieser Abschnitt prüft.",
damageTip: "Gehen Sie nah heran und fotografieren Sie flach entlang der Fläche — Dellen zeigen sich in den Spiegelungen.",
checklistToggle: "Was aufnehmen · {{done}}/{{total}}",
checklistToggleNoCount: "Was aufnehmen",
found: "gefunden",
removeFrameA11y: "Foto {{index}} entfernen",
lowLight: "Mehr Licht nötig",
limitReached: "Fotolimit erreicht. Entfernen Sie eines, um ein weiteres hinzuzufügen.",
costHint_one: "Die Analyse verbraucht {{count}} Credit · {{balance}} verfügbar",
costHint_other: "Die Analyse verbraucht {{count}} Credits · {{balance}} verfügbar",
shutterA11y: "Foto aufnehmen",
finishCount: "Scan abschließen ({{count}})",
cameraBlocked: "Der Kamerazugriff ist deaktiviert. Aktivieren Sie ihn in den Einstellungen oder fügen Sie stattdessen Fotos hinzu.",
cameraNeeded: "Erlauben Sie den Kamerazugriff zum Scannen oder fügen Sie stattdessen Fotos hinzu.",
openSettings: "Einstellungen öffnen",
grant: "Kamera erlauben",
webNoLocal: "Fotos werden hier von AssetWRX in der Cloud geprüft. Sie prüfen alles, bevor es gespeichert wird.",
upload: "Fotos hochladen",
useCamera: "Kamera verwenden",
fromPhotos: "Aus Fotos hinzufügen",
failed: "Das Foto konnte nicht hinzugefügt werden. Bitte erneut versuchen.",
seedFailed: "Das Foto konnte nicht geöffnet werden. Nehmen Sie ein neues auf oder fügen Sie eines aus Ihren Fotos hinzu.",
},
stage: {
reading_labels: "Beschriftungen werden gelesen…",
checking_items: "Prüfpunkte werden abgeglichen…",
reviewing_condition: "Sichtbarer Zustand wird bewertet…",
preparing_results: "Ergebnisse werden vorbereitet…",
},
coverage: {
observed: "Gesehen",
partial: "Teilweise gesehen",
not_observed: "Nicht gesehen",
},
cloud: {
offline: "Sie sind offline, daher werden nur Ergebnisse vom Gerät angezeigt.",
switched_off: "Die Cloud-Analyse ist für diesen Arbeitsbereich deaktiviert. Es wird nur angezeigt, was das Gerät erkennen konnte.",
nothing_to_scan: "In diesem Abschnitt lässt sich nichts aus einem Foto ablesen. Beantworten Sie die Prüfpunkte selbst.",
no_credits: "Nicht genug KI-Guthaben für die Cloud-Analyse. Es wird nur angezeigt, was das Gerät erkennen konnte.",
timeout: "Die Cloud-Analyse hat zu lange gedauert. Es wird nur angezeigt, was das Gerät erkennen konnte.",
blocked_content: "Diese Fotos konnten in der Cloud nicht analysiert werden. Es wird nur angezeigt, was das Gerät erkennen konnte.",
failed: "Die Cloud-Analyse wurde nicht abgeschlossen. Es wird nur angezeigt, was das Gerät erkennen konnte.",
analyseNow: "Jetzt mit KI analysieren · {{cost}}",
retry: "Cloud-Analyse erneut versuchen",
},
review: {
title: "Vorschläge prüfen",
emptyTitle: "Diese Prüfpunkte ließen sich aus dem Scan nicht bestimmen",
emptyBody: "Scannen Sie erneut mit gut sichtbarem Objekt oder beantworten Sie die Prüfpunkte selbst.",
summaryReady: "Bereit: {{count}}",
summaryCheck: "Zu prüfen: {{count}}",
summaryNotSeen: "Nicht gesehen: {{count}}",
summaryIssues: "Mögliche Mängel: {{count}}",
frameA11y: "Scan-Foto {{index}}",
readyTitle: "Bereit zur Bestätigung",
checkTitle: "Bitte prüfen",
notObservedTitle: "Nicht gesehen",
issuesTitle: "Weitere Mängel",
coverageTitle: "Was der Scan abgedeckt hat",
acceptReady: "Bereite Antworten übernehmen ({{count}})",
bulkSaved: "Gespeicherte Antworten: {{count}}",
undo: "Rückgängig",
done: "Fertig",
scanAgain: "Erneut scannen",
completeManually: "Manuell beantworten",
leaveTitle: "Ohne Prüfung verlassen?",
leaveBody: "Einige Vorschläge aus diesem Scan wurden noch nicht geprüft. Wenn Sie jetzt gehen, werden sie verworfen.",
keepReviewing: "Weiter prüfen",
discard: "Verwerfen",
observed: "Gesehen",
suggested: "Vorgeschlagen",
differs: "Weicht von Ihrer Antwort ab. Übernehmen ersetzt sie.",
partial: "Nur teilweise sichtbar. Vor dem Übernehmen prüfen.",
conflict: "Die Ablesungen stimmen nicht überein. Wählen Sie den richtigen Wert.",
previousReading: "Zuletzt erfasst: {{value}}",
backwards: "Niedriger als der zuletzt erfasste Zählerstand.",
unitMismatch: "Dieser Zähler wird in {{unit}} erfasst.",
serialMismatch: "Stimmt nicht mit der erfassten Seriennummer dieser Anlage überein.",
accept: "Übernehmen",
change: "Ändern",
reject: "Verwerfen",
save: "Speichern",
possibleIssue: "Möglicher Mangel",
confirmIssue: "Mangel bestätigen",
flagIssue: "Zur Prüfung markieren",
noIssue: "Kein Mangel",
decision: {
accepted: "Gespeichert",
changed: "Mit Ihrer Änderung gespeichert",
rejected: "Nicht verwendet",
fail: "Zu „Weitere Befunde“ hinzugefügt",
flag: "In „Weitere Befunde“ markiert",
dismissed: "Verworfen",
},
reason: {
not_observed: "Auf den Fotos nicht sichtbar.",
partial: "Nur teilweise sichtbar.",
low_confidence: "Nicht deutlich genug für einen Vorschlag.",
no_evidence: "Nichts im Scan beantwortet diesen Punkt.",
},
},
defect: {
corrosion: "Korrosion",
leak: "Leck",
crack: "Riss",
wear: "Verschleiß",
deformation: "Verformung",
missing_component: "Fehlendes Bauteil",
loose_component: "Lockeres Bauteil",
damage: "Beschädigung",
contamination: "Verschmutzung",
damp_staining: "Feuchtigkeitsflecken",
mould_growth: "Schimmelähnlicher Befall",
blockage: "Verstopfung",
overheating: "Überhitzung",
dent: "Delle",
scratch: "Kratzer",
paint_damage: "Lackschaden",
glazing_damage: "Glasschaden",
light_damage: "Leuchtenschaden",
tyre_damage: "Reifenschaden",
cable_damage: "Kabelschaden",
exposed_wiring: "Freiliegende Leitungen",
misalignment: "Fehlausrichtung",
blocked_access: "Versperrter Zugang",
other_visible_anomaly: "Etwas, das geprüft werden sollte",
},
trainingShare: {
title: "Daten zur Verbesserung von Vision",
body: "Vision speichert ohne Fotos, welche Vorschläge Ihr Team angenommen, geändert oder abgelehnt hat, um die Genauigkeit zu messen. Diese Einstellung ist standardmäßig aktiviert: Die Nachweisfotos, die Ihr Team zu diesen Vorschlägen aufbewahrt hat, werden auch zum Training von Vision verwendet. Sie werden für das Training in die Google Cloud in der EU kopiert und dort innerhalb von 30 Tagen gelöscht. Durch das Deaktivieren endet jede weitere Nutzung; ein bereits damit trainiertes Modell wird nicht zurückgesetzt. Die Aufzeichnungen werden 24 Monate aufbewahrt.",
toggle: "Unsere Nachweisfotos zur Verbesserung von Vision nutzen",
on: "Ein. Nachweisfotos zu geprüften Vorschlägen dürfen zum Trainieren von Vision in die Google Cloud (EU) kopiert werden.",
off: "Aus. Es werden nur die Prüfentscheidungen gespeichert, ohne Fotos.",
failed: "Die Einstellung konnte nicht geändert werden. Bitte erneut versuchen.",
retry: "Wiederholen",
},
},
ratingScale: {
poor: "Schlecht",
fair: "Mäßig",
good: "Gut",
veryGood: "Sehr gut",
excellent: "Ausgezeichnet",
low: "Niedrig",
quarter: "Viertel",
half: "Halb",
threeQuarter: "Dreiviertel",
full: "Voll",
},
};
